var map = {
	"./White-Bishop.svg": 90200,
	"./White-King.svg": 12274,
	"./White-Knight.svg": 65532,
	"./White-Pawn.svg": 37097,
	"./White-Queen.svg": 60515,
	"./White-Rook.svg": 41640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5324;